var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-width-1-1 uk-text-right@m"},[_c('a',{staticClass:"uk-button uk-button-primary uk-width-1-1 uk-width-auto@m",on:{"click":function($event){return _vm.createAddress()}}},[_vm._v("\n        "+_vm._s(_vm.$t('rubinred.ecommerce.core.action.add_address'))+"\n    ")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8ac108","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/addressing/AddressAdd.vue
// module id = rmIt
// module chunks = 0